<div class="compare-wrapper">Compare - component</div>
